const SUBSCRIBE_URL = 'https://a.klaviyo.com/ajax/subscriptions/subscribe';

export function subscribeToList({ listId = '', email = '', source = '', interest = '', profileSubscribeUtms = {} }) {
  return new Promise(function (resolve, reject) {
    const data = new URLSearchParams();
    data.append('g', listId);
    data.append('email', email);
    const listSource = source === 'Entry Modal' ? 'Entrance Modal' : source;
    data.append('$source', listSource);
    data.append('Source', listSource);
    data.append('customSource', listSource);
    if (window.innerWidth <= 500) {
      data.append('schoolInterest_Mobile', interest);
    } else {
      data.append('schoolInterest_Desktop', interest);
    }
    const uniqueSource = source.toLowerCase().replace(/\s+/g, '_');
    data.append('$source_' + uniqueSource, listSource);

    let subscribeSourceUtms = '';
    for (const [key, value] of Object.entries(profileSubscribeUtms)) {
      if (key && value) {
        subscribeSourceUtms += `, ${key}`;
        data.append(`${key}`, `${value}`);
      }
    }
    data.append(
      '$fields',
      '$source, Source, customSource, schoolInterest_Mobile, schoolInterest_Desktop, $source_' +
        uniqueSource +
        subscribeSourceUtms
    );
    const dataEncoded = data.toString();
    const request = new XMLHttpRequest();
    request.open('POST', SUBSCRIBE_URL, true);
    request.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
    request.setRequestHeader('Cache-control', 'no-cache');
    request.onload = function () {
      if (request.status == 200) {
        resolve(request.response);
      } else {
        reject(Error(request.statusText));
      }
    };
    request.onerror = function () {
      reject(Error('Network Error'));
    };
    request.send(dataEncoded);
  });
}
export function sendProducts({ products }) {
  if (products.length < 1) {
    return;
  }
  window._learnq = window._learnq || [];
  window._learnq.push([
    'track',
    'rugsTinder',
    {
      products: products,
    },
  ]);
}
export function sendCartProducts(email, cart) {
  if (!cart && cart.item_count < 1) {
    return;
  }
  window._learnq = window._learnq || [];
  window._learnq.push([
    'identify',
    {
      $email: email || '',
    },
  ]);
  window._learnq.push(['track', 'save_cart', cart]);
}
export function sendFavoriteProducts(email, favorites) {
  if (!favorites && favorites.length < 1) {
    return;
  }
  const faveIds = [];
  const geoLocale = JSON.parse(localStorage.getItem('geoLocale'));
  const currency = (geoLocale && geoLocale.currencySymbol) || '$';
  favorites.map((object) => {
    if (object.images) {
      const productImage = String(object.images.split(',')[0]);
      const featuredImage = productImage && !productImage.includes('https') ? `https:${productImage}` : productImage;
      object.featured_image = featuredImage || object.images;
    }
    if (object.name) {
      const name = object.name && object.name.replace(/(<([^>]+)>)/gi, ''); //remove any possible tags
      object.name = name;
    }
    if (object.price) {
      const priceRange = object.price && String(object.price).includes(',') && String(object.price).split(',');
      if (priceRange) {
        const priceRangeCombined = priceRange.map((str) => {
          const formattedRange = str
            .split('.')[0]
            .replace(/[`~!@#$£%^&*()_|+\-=?;:'"<>\{\}\[\]\\\/]/gi, '')
            .trim();
          return `${currency}${formattedRange}`;
        });
        object.price = priceRangeCombined.join(' - ');
      } else {
        const noformat = object.price && String(object.price).replace('.00', '');
        object.price = noformat;
      }
    }
    if (object.productId) {
      faveIds.push(object.productId);
    }
  });

  window._learnq = window._learnq || [];
  const fireSaveFavoriteTrack = () => {
    window._learnq.push(['track', 'save_favorites', { favorites: favorites }]);
  };
  const identifyProps = {
    $email: email,
    favorite_rugs: faveIds,
  };
  window._learnq.identify(identifyProps, undefined, undefined, fireSaveFavoriteTrack);
}

export function getListId(locale) {
  if (localStorage.getItem('env') === 'dev') {
    return 'TmDkQL';
  }
  locale = locale || localStorage.locale;
  const listIds = {
    'en-US': 'U49ncs',
    'en-GB': 'JN2pqu',
    'en-AU': 'SYmGJ8',
    'de-DE': 'RyUXDm',
  };
  return listIds[locale] || listIds['en-US'];
}
